import { Card, RingProgress, Stack, Text, ThemeIcon, rem } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import React from "react";
import { ReadingRiskResult } from "../utils/ReadingRiskUtils";

interface Props {
  risk: ReadingRiskResult;
}

export const ReadingRiskGauge: React.FC<Props> = ({ risk }) => {
  const percentage = Math.max(3, Math.min(97, (risk.totalScore / 7) * 100));
  const riskColor = risk.riskColor === "orange" ? "orange" : risk.riskColor;

  if (risk.isInconclusive) {
    return (
      <Card withBorder radius="md" p="md" h="100%">
        <Stack align="center" justify="center" gap="xs" h="100%">
          <ThemeIcon color="gray" size={56} radius="xl" variant="light">
            <IconAlertCircle size={32} />
          </ThemeIcon>
          <Text fw={700} size="md" c="dimmed" ta="center">
            No Score
          </Text>
          <Text size="xs" c="dimmed" ta="center" px="md">
            Comprehension check suggests the passage may not have been read attentively.
          </Text>
        </Stack>
      </Card>
    );
  }

  return (
    <Card withBorder radius="md" p="md" h="100%">
      <Stack align="center" justify="center" gap={4} h="100%">
        <RingProgress
          size={140}
          thickness={14}
          roundCaps
          sections={[{ value: percentage, color: riskColor }]}
          label={
            <Stack gap={0} align="center">
              <Text fz={rem(24)} fw={900} c={riskColor} style={{ lineHeight: 1 }}>
                {Math.round(percentage)}%
              </Text>
              <Text fz="10px" fw={700} c="dimmed" tt="uppercase">
                Risk Level
              </Text>
            </Stack>
          }
        />

        <Stack gap={2} align="center">
          <Text fw={700} size="sm" c={riskColor} ta="center">
            {risk.riskLabel}
          </Text>
          <Text size="xs" c="dimmed" ta="center" px="md">
            Score: {risk.totalScore} / 7
          </Text>
        </Stack>
      </Stack>
    </Card>
  );
};
